import { render, staticRenderFns } from "./TaskAddedSubtask.vue?vue&type=template&id=7ba04c31&scoped=true"
import script from "./TaskAddedSubtask.vue?vue&type=script&lang=js"
export * from "./TaskAddedSubtask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba04c31",
  null
  
)

export default component.exports